// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27light-grey%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-card {
  border-radius: 4px;
  border: solid 1px #cfcfcf;
  background-color: #fff;
  padding: 14px;
}
.noresult-found {
  font-size: 12px;
  margin-top: 30px;
  opacity: 0.7;
  text-align: center;
}

.custom-card-label {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d9da6;
  text-transform: capitalize;
  margin: 0px;
}

.disable-button {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-hover:hover {
  cursor: pointer;
}

.model-absolute-position {
  position: absolute;
  left: 47%;
  top: 47%;
}

.popup-yellow-background {
  width: 100%;
  height: 40px;
  border-radius: 4px;
  margin: 5px 0px;
  text-align: center;
  background-color: #f5e12d80;
  display: block;
}

.payments-none-disclaimer-1 {
  color: #6b6b6b;
  font-size: 0.8rem;
  /* padding-top: 1rem; */
  display: flex;
  justify-content: center;
}

.low-underline {
  display: block;
  height: 2px;
  width: 100%;
  background-color: #f0f0f5;
  position: absolute;
  top: 65px;
  z-index: 98;
}

.custom-card-text {
  margin: 0px;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
}

.custom-tag {
  font-size: 12px;
  border-radius: 100px;
  background-color: #e9e9e9b4;
  padding: 2px 0px;
  /* max-width: 70px; */
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 10px;
}

.custom-tag-image {
  height: 24px;
}

.action-button-pink {
  color: #eb4f85;
  font-size: 20px;
  margin-left: 10px;
}

.full-height-layout {
  height: 100vh;
  background-color: #f0f0f0;
  padding: 20px;
}

.full-height-layout-90 {
  height: 85vh;
  background-color: #f0f0f09f;
  padding: 20px;
  border-radius: 4px;
  width: 300px;
}

.flex-column-padding-15 {
  display: flex;
  flex-direction: column;
  padding: 15px;
  align-items: flex-start;
}

.flex-column-gap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.raw-flex-row {
  display: flex;
  flex-flow: row wrap;
}

.raw-flex-row-center {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.raw-flex-col-center {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.raw-flex-row-reverse {
  display: flex;
  flex-direction: row-reverse;
}

.flex-row {
  display: flex;
  flex-direction: row;
  margin: 5px 0px;
  align-items: center;
}

.flex-row-start {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
}

.flex-row-full-width {
  display: flex;
  flex-direction: row;
  margin: 5px 0px;
  align-items: center;

  flex: 1;
  justify-content: space-between;
  width: 100%;
}

.flex-row-center {
  display: flex;
  flex-direction: row;
  margin: 5px 0px;
  align-items: center;
  justify-content: center;
}

.flex-row-vertical-center {
  display: flex;
  flex-direction: row;
  margin: 5px 0px;
  justify-content: space-between;
}

.flex-row-horizontal-gap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}

.flex-row-gap-start {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
}

.flex-row-end {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.flex-row-gap {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
}

.underline {
  display: block;
  min-width: 76px;
  height: 2px;
  background-color: #eb4f85;
  z-index: 100;
  position: absolute;
  top: 65px;
}

.tab-header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
}

.tab-header-name {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #787887;
}

.tab-header-name:hover {
  cursor: pointer;
}

.tab-header-name-active {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #f05a9b;
}

.tab-header-item {
  text-align: center;
  justify-content: center;
  min-width: 76px;
  margin-right: 15px;
}

.tab-body {
  margin-top: 15px;
}

.meesho-primary-button {
  min-width: 114px;
  height: 30px;
  border-radius: 4px;
  border: solid 1px #eb4f85;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #eb4f85;
}
.meesho-primary-button:hover {
  background-color: #eb4f85;
  color: #fff;
  cursor: pointer;
}

.meesho-primary-active-button {
  margin: 0px 15px;
  width: 114px;
  height: 30px;
  border-radius: 4px;
  border: solid 1px #eb4f85;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  background-color: #eb4f85;

  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #fff;

  cursor: pointer;
}

.meesho-primary-active-button:hover {
  cursor: pointer;
}

.right-shift {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.box {
  width: 166px;
  height: 30px;
  border-radius: 2px;
  border: solid 1px #dcdcdc;
  padding: 0px 3px;
  padding-left: 5px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.box-row {
  width: 166px;
  height: 30px;
  border-radius: 2px;
  border: solid 1px #dcdcdc;
  padding: 0px 6px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 7px;
}

.input-placeholer {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d9da6;
  margin-top: 5px;
}

.box-input {
  min-width: 166px;
  height: 30px;
  border-radius: 2px;
  border: solid 1px #dcdcdc;
  padding: 0px 3px;
  padding-left: 5px;
  padding-right: 20px;

  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d9da6;

  /* background-color: #dcdcdc; */
}

.fluid-row {
  width: 100%;
}

.fluid-row-padding-10 {
  width: 100%;
  padding: 0px 10px;
}

.fluid-row-full-flex {
  width: 100%;
  padding: 0px 10px;
  flex: 1;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.flex-3 {
  flex: 3;
}

.flex-4 {
  flex: 4;
}

.flex-5 {
  flex: 5;
}

.flex-6 {
  flex: 6;
}

.table-body-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #52616a;
}

.table-image {
  height: 45px;
  width: 45px;
  border-radius: 4px;
}

.table-footer-mid-text {
  background-color: #f5f5f5;
  margin: 0px 15px;
  padding: 7px 14px;
  border-radius: 4px;
}

.table-default-horizontal-gap {
  margin: 0px 25px;
}

.table-default-vertical-gap {
  margin: 30px 0px;
}

.table-header-row {
  border: 0px;
  background-color: #f2f2f2;
  padding: 10px;
}
.table-header{
  border-top: 1px solid #000;
}

.text-left {
  text-align: left !important;
}

.table-item-align-left {
  border: 0px;
  text-align: left;
}

.circle {
  width: 9px;
  height: 9px;
  width: 10px;
  min-width: 10px;
  height: 10px;
  min-height: 10px;
  border-radius: 100px;
  background-color: #000;
  border: 0.3px solid rgb(187, 187, 187);
}

.maximum-width-650 {
  max-width: 650px;
}

.color-picker-input-box {
  border: 1px solid #dcdcdc;
  margin-left: 5px;
  padding: 5px 10px;
  font-size: 13px;
  height: 30px;
  display: flex;
  flex-direction: row;
  position: relative;
  cursor: pointer;
  min-width: 150px !important;
}

.color-picker-input-box-ul {
  background-color: rgb(255, 255, 255);
  padding: 5px 3px;
  opacity: 1;
  color: #9d9d9d;
  position: absolute;
  z-index: 100;
  min-width: 150px !important;
  font-size: 13px;
  border: 1px solid rgb(129, 129, 129);
  border-radius: 4px;
  right: 15px;
  border-top-width: 0px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  padding-left: 5px;
}

.color-picker-input-box-ul-li {
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.color-picker-color-circle {
  margin-right: 5px;
  height: 15px;
  width: 15px;
  border-radius: 100px;
  /* background-color: red; */
  border: 0.5px solid rgba(141, 141, 141, 0.753);
}

.color-picker-input-box-ul-li-circle {
  margin-right: 5px;
  height: 10px;
  width: 10px;
  border-radius: 100px;
  /* background-color: red; */
  border: 0.5px solid rgba(144, 144, 144, 0.753);
  margin-top: 3px;
}

.circle-color-red {
  background-color: #f05a9b;
  margin-right: 8px;
}

.circle-color-orange {
  background-color: #f6691e;
  margin-right: 8px;
}
.circle-color-green {
  background-color: #06a759;
  margin-right: 8px;
}

.position-relative {
  position: relative;
}

.floating-error-message-input-field {
  margin-top: -3px;
}

.position-absolute-bottom-10 {
  position: absolute;
  bottom: 0px;
}

.position-relative-z-200 {
  position: relative;
  z-index: 200;
}

.position-absolute-top-right {
  position: absolute;
  top: 5px;
  right: 5px;
}

.position-absolute-top-right-10 {
  position: absolute;
  top: 10px;
  right: 10px;
}

.position-absolute-top-right-15 {
  position: absolute;
  top: 15px;
  right: 15px;
}

.position-absolute-top-right-20 {
  position: absolute;
  top: 20px;
  right: 20px;
}

.position-absolute-right {
  position: absolute;
  right: 10;
  bottom: 1;
}

.margin-height-width-0 {
  margin: 0px !important;
}

.top-padding-10 {
  padding-top: 10px;
}

.bottom-margin--15 {
  margin-bottom: -15px;
}

.horizontal-align-top {
  align-items: top;
}

.flex-row-horizontal-gap-one {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
  text-align: left;
}

.inline-text-link-one {
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #f05a9b !important;
}

.inline-text-link-one:hover {
  cursor: pointer;
}

.margin-horizontal-5 {
  margin: 0px 5px;
}

.normalise-link-button a {
  color: #ffffff;
  text-decoration: none;
}

.inline-text-icon {
  width: 12px;
  height: 12px;
}

.align-center-envelop {
  margin-top: 4px;
  font-size: 16px;
}

.position-absolute-right-1 {
  position: absolute;
  right: 0px;
  bottom: 1;
}

.dispaly-block {
  display: block;
  margin-bottom: 25px;
}

.deafult-margin-top {
  margin-top: 20px;
}

.half-padding {
  padding: 10px;
  border-radius: 4px;
}

.margin-left-45-par {
  margin-left: 45%;
}

.margin-left-5 {
  margin-left: 5px;
}

.text-align-left-x {
  text-align: left;
  border: 0px;
}

.clip-scroll {
  max-height: 60vh;
  overflow-y: scroll;
}

.padding-5 {
  padding: 5px;
}

.text-button {
  color: #eb4f85;
}

.text-button:hover {
  cursor: pointer;
}

.button-hover:hover {
  cursor: pointer;
}

.checkbox {
  background-color: pink;
  color: pink;
  border-color: pink;
  background: pink;
  border: pink 1px solid;
}

.checkbox:checked {
  background-color: pink;
}

.checkbox:hover {
  cursor: pointer;
}

.bar-1 {
  width: 1px;
  height: 16px;
  opacity: 0.2;
  background-color: #000000;
  margin: 15px;
}

.bar-32 {
  width: 2px;
  height: 33px;
  opacity: 0.2;
  background-color: #000000;
  margin: 0px 15px;
}

.bar-30 {
  width: 100%;
  height: 1px;
  background-color: #d7d7e0;
  margin: 30px 0px;
}

.bar-96 {
  width: 100%;
  height: 1px;
  background-color: #d7d7e0;
  margin: 25px 0px;
}

.bar-40 {
  width: 1px;
  height: 249px;
  opacity: 0.2;
  background-color: #000000;
  margin: 0px 25px;
}

.bar-100 {
  width: 1px;
  height: 244px;
  background-color: #d7d7e0;
}

.path-4 {
  width: 1px;
  height: 70px;
  border: solid 1px #06a759;
  position: absolute;
  left: 10px;
  top: 4px;
  z-index: 198;
}

.heading-normal-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
}

.midium-size-image {
  width: 145.1px;
  height: 181.4px;
  border-radius: 4px;
}

.text-group-1-label {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #787887;

  margin-bottom: 2px;
}

.text-group-1-body {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202024;

  /* max-width: 151px; */
}

.text-group-2-heading {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
}

.text-group-2-label {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #787887;
  margin-bottom: 0px;
  text-transform: capitalize;
}

.text-group-2-heading-lite {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #212121;
}

.text-group-2-caption {
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d9da6;
  margin-bottom: 0px;
}

.text-transform-uppercase {
  text-transform: uppercase;
}

.text-group-2-caption-lite {
  font-size: 10px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d9da6;
  margin-bottom: 0px;
  margin: 0px;
  margin-top: -10px;
}

.text-group-2-caption-lite-1 {
  font-size: 10px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d9da6;
  margin-bottom: 10px;
  margin-top: -6px;
}
.text-group-2-caption-header {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #787887;
}

.text-group-2-caption-pink {
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #f05a9b;
}

.text-group-2-caption-pink:hover {
  cursor: pointer;
}

.text-group-2-body {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
}

.text-group-3-label {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #9d9da6;
  margin-top: 14px;
  margin-bottom: 0px;
}

.text-group-4-label {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #0a0a0a;
  margin-top: -10px;
  margin-bottom: 0px;
}

.model-textarea {
  width: 100%;
  margin: 15px 0px;
  border-color: rgb(129, 129, 129);
}

.text-group-3-body {
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
}

.margin-right-5 {
  margin-right: 5px;
}

.margin-right-15-padding-10 {
  margin-right: 15px;
  padding: 0px 10px;
}

.green-circle {
  margin-right: 22px;
  margin-left: 7px;
  z-index: 200;
  display: block;
  background-color: green;
  height: 8px;
  width: 8px;
  border-radius: 100px;
  z-index: 300;
}

.gray-circle {
  margin-right: 22px;
  margin-left: 7.1px;
  z-index: 200;
  display: block;
  background-color: rgb(255, 255, 255);
  height: 7px;
  width: 7px;
  border: 1px solid rgb(133, 133, 133);
  border-radius: 100px;
  z-index: 300;
}

.green-big-circle {
  z-index: 398;
  top: -2px;
  position: absolute;
  display: block;
  opacity: 0.24;
  background: rgb(255, 255, 255);
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgba(6, 167, 89, 1) 100%
  );
  height: 22px;
  width: 22px;
  border-radius: 100px;
}

.orange-circle {
  margin-right: 22px;
  margin-left: 7px;
  z-index: 200;
  display: block;
  background-color: #ff9115;
  height: 8px;
  width: 8px;
  border-radius: 100px;
  z-index: 300;
}

.orange-big-circle {
  z-index: 298;
  top: -2px;
  position: absolute;
  display: block;
  opacity: 0.24;
  background: rgb(255, 255, 255);
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 0%,
    rgba(246, 105, 30, 1) 100%
  );
  height: 22px;
  width: 22px;
  border-radius: 100px;
}

.red-outer-circle {
  margin-right: 15px;
  display: block;
  background-color: red;
  height: 22px;
  width: 22px;
  border-radius: 100px;
  opacity: 0.2;
}

.red-inner-circle {
  position: absolute;
  top: 7px;
  left: 7px;
  display: block;
  background-color: red;
  height: 8px;
  width: 8px;
  border-radius: 100px;
}

.flex-bar {
  display: block;
  height: 100%;
  width: 1.5px;
  background-color: green;
  opacity: 0.6;
  flex: 1;
  position: absolute;
}

.margin-left-10 {
  margin-left: 10px;
}

.margin-tpp-5 {
  margin-top: 5px;
}

.maximum-width-850 {
  max-width: 850px;
}

.popup-position-top {
  max-width: 70vw;
  min-width: 750px;
  top: 300;
}

.iframe-pdf {
  width: 100%;
  min-height: 340px;
  padding-top: -100px;
  margin: 10px 0px;
}
.min-width-100 {
  min-width: 100px;
}

.maximum-height-1000-scroll {
  margin-top: 100px;
  max-width: 800px;
  overflow-y: scroll;
}

.top-500 {
  top: 500px;
}

.color-red {
  font-size: 12px;
  color: red;
}

.maximum-height-600-scroll {
  max-height: 600px;
  overflow-y: scroll;
}

.maximum-width-750 {
  max-width: 750px;
}

.maximum-width-600 {
  max-width: 600px;
}

.maximum-width-400 {
  max-width: 400px;
}

.maximum-width-300 {
  max-width: 300px;
}

.maximum-width-200 {
  max-width: 200px;
}

.maximum-width-250 {
  max-width: 250px;
}

.maximum-width-270 {
  max-width: 270px;
}

.maximum-width-280 {
  max-width: 280px;
}

.maximum-width-550 {
  max-width: 550px;
}

.maximum-width-315 {
  max-width: 315px;
}

.padding-horizontal-5 {
  padding: 0px 5px;
}

.padding-horizontal-10 {
  padding: 0px 10px;
}

.model-header-text-h1 {
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  text-transform: capitalize;
}

.document-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.model-1-image {
  width: 156.8px;
  height: 196px;
}

.input-1-textbox {
  width: 689px;
  height: 68px;
  border: solid 1px #e6e6e6;
}

.model-1-heading {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
}

.input-1-label {
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
}

.input-1-field {
  width: 338px;
  height: 33px;
  border: solid 1px #e6e6e6;
}

.pink-bold-text {
  text-transform: capitalize;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #eb4f85;
}

.minimum-width-150 {
  min-width: 150px;
}

.margin-left-35 {
  margin-left: 35px;
}
.minimum-width-270 {
  min-width: 270px;
}

.white-line {
  background-color: white;
  z-index: 700;
  margin-top: 14px;
  opacity: 1;
  width: 3px;
}

.text-bold-1 {
  font-weight: 700;
  color: #202024;
  font-size: 14px !important;
}

.test-group-2 {
  font-weight: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #787887;
  font-size: 14px;
}

.text-group-3 {
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #787887;
  font-size: 12px;
}

.margin-top--5 {
  margin-top: -5px;
}
.dotted-box {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  border: dotted 1px #eb4f85;
  background-color: #fff;
  margin-right: 15px;
}

.dotted-image-box {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  margin: 15px;
  margin-left: 0px;
  margin-bottom: 0px;
}

.color-primary {
  color: #eb4f85;
}

.image-add-button {
  position: absolute;
  top: 40px;
  left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.lite-border {
  border-radius: 4px;
  border: solid 1px #f0f0f5;
}

.search-box {
  width: 269px;
  height: 33px;
  border-radius: 6px;
  border: solid 1px #e6e6e6;
  padding-left: 30px;
}

.option_bottom_border {
  width: 100%;
  border-bottom: 1px solid #d7d7e0;
  text-align: left;
  padding: 10px 0px;
  padding-bottom: 0px;

  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.86;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
  margin-top: 5px;
}

.option_bottom_border:hover {
  cursor: pointer;
}

.search-input-background {
  padding: 40px 40px;
  border-radius: 4px;
  background-color: #f0f0f5;
}

.margin-horizontal-10 {
  margin: 0px 5px;
}

.margin-vertical-30 {
  margin: 30px 0px;
}

.submit-button {
  border: 0px;
  width: 343px;
  height: 47px;
  border-radius: 4px;
  background-color: #f05a9b;
  text-align: center;

  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
}

.autosuggest-inputbox {
  height: 52px;
  border-radius: 6px;
  border: solid 1px #e6e6e6;
  background-color: #fff;
}

.search-box-holder {
  margin-top: 10vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bonus-box {
  border-radius: 2px;
  border: solid 1px #d7d7e0;
  padding: 10px;
  margin-right: 20px;
}

.bonus-box-label {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #53616a;
}

.bonus-box-text {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #202024;
  margin-bottom: 0px;
}

.bonus-section-heading {
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #53616a;
}

.text-align-right-x {
  text-align: right;
  border: 0px;
}

.table-bonus-row {
  height: 80px;
}

.margin-bottom-6 {
  margin-bottom: 6px;
}

.margin-bottom-3 {
  margin-bottom: 3px;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-right-15 {
  margin-right: 15px;
}

.margin-right-35 {
  margin-right: 35px;
}

.disposition-select {
  background-color: #5c8dff;
  color: #fff;
  border: 0px;
  border-radius: 4px;
  padding-left: 10px;
  padding-bottom: 7px;
  padding-top: 7px;
}

.minimum-width-300 {
  min-width: 300px;
}

.long-textarea {
  width: 100%;
  height: 199px;
  border: solid 1px #e6e6e6;
  background-color: #fff;
}

.margin-top-8 {
  margin-top: 8px;
}

.payments-col {
  height: 611px;
  border: solid 1px #f0f0f5;
  overflow-y: auto;
}

#agent-dashboard-payments-message-col table tr th,
#agent-dashboard-payments-message-col table tr td {
  border: 0 !important;
  min-width: 10rem;
  margin: 2rem 0 1rem 2rem;
  padding: 1rem !important;
  line-height: 1.5rem;
  font-size: 0.8rem;
}

#agent-dashboard-payments-message-col table tr:nth-child(odd),
#agent-dashboard-referral-tab-table-container table tr:nth-child(odd) {
  background-color: #f5f5f5;
}

.payments-none-disclaimer {
  color: #b4b4be;
  padding-top: 2rem;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
}

.agent-dashboard-tab-info-box-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 1.5rem;
}

.info-box-container {
  border-radius: 2px;
  border: solid 1px #d7d7d7;
  margin-right: 0.5rem;
  padding: 0.1rem 0.8rem 0.4rem;
  min-width: 7.5rem;
  width: fit-content;
}

.info-box-title {
  color: #787887;
  font-size: 0.7rem;
}

.info-box-value {
  font-weight: 500;
  color: #202020;
  font-size: 1rem;
  margin: 0;
}

.search-box-container {
  width: max-content;
  border: 1px solid #d7d7d7;
  padding: 0.2rem 0.5rem 0.3rem;
  margin-right: 0.5rem;
}

input.search-box-input {
  border: none;
  font-size: 0.7rem;
}

input.search-box-input::placeholder {
  color: #9d9d9d;
}

.search-box-container i.fa.fa-search.search-box-icon {
  color: #d7d7d7;
  padding: 0 0.2rem;
  position: inherit !important;
  cursor: pointer;
}

#agent-dashboard-referral-tab-table-container {
  margin-top: 1.2rem;
}

#agent-dashboard-referral-tab-table-container table th {
  text-align: left;
  border: none;
  width: 130px;
  padding-left: 1.5rem;
  word-break: break-word;
}
.referral-table-heading-tr {
  border: 1px solid #dcdcdc;
}

.link-type-button {
  background: transparent;
  border: none;
  font-size: 0.8rem;
  color: #f05a9b;
  padding: 0;
  margin: 0;
}

.link-type-button:focus {
  outline: none;
}

.agent-dashboard-referral-tab-container {
  margin-right: 1.5rem;
}

#agent-dashboard-referral-tab-table-container table td {
  font-size: 0.8rem;
  color: #52616a;
  padding: 1.25rem 0 1.25rem 1.5rem !important;
}

#agent-dashboard-referral-tab-table-container table {
  width: 100%;
}

.table-pagination-nav-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
}

.table-pagination-nav-container select {
  border: none;
  border-radius: 2px;
  background-color: #f5f5f5;
  padding: 0.2rem 0.5rem;
  font-size: 0.8rem;
}

.table-pagination-nav-container select:focus {
  outline: none;
}

.table-pagination-summary {
  font-size: 0.8rem;
  color: #787878;
  padding-left: 0.5rem;
  padding-right: 1rem;
}

.table-pagination-nav-container a {
  text-decoration: none;
  cursor: pointer;
  color: #ccc;
  font-size: 1rem;
  padding: 0.5rem;
}

.table-pagination-nav-container a:hover {
  color: black;
}

.table-pagination-current-page-text {
  background-color: #f5f5f5;
  color: #666;
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
  border-radius: 2px;
  cursor: pointer;
}

.referral-tab-table-arrow-navigation-container {
  margin-left: 5rem;
}

.return-to-referral-overview-container {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.return-to-referral-text {
  margin-left: 0.5rem;
}

.common-tab-buttons {
  background-color: transparent;
  color: #787878;
  border: none;
  font-size: 0.7rem;
  min-width: 7rem;
  margin: 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid transparent;
  font-weight: 500;
}

.common-tab-buttons:focus,
.user-account-verify-account-container button:focus {
  outline: none;
}

.active-tab-button {
  color: #f05a9b;
  border-bottom: 2px solid #f05a9b;
  font-weight: 500;
}

.common-tab-content-container {
  padding-top: 1rem;
  border-top: 2px solid #f5f5f5;
  margin-top: -2px;
}

.agent-dashboard-user-account-tab-container h5 {
  text-transform: capitalize;
}

.agent-dashboard-user-account-tab-container td button.link-type-button {
  margin: 0 1rem 0 0;
  font-weight: 500;
}

.card-container {
  background-color: #ffffff;
  width: 390px;
  padding: 1rem;
}

.agent-dashboard-modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-modal-btn {
  color: #ffffff;
  background: #666;
  border-radius: 50%;
  height: 1rem;
  width: 1rem;
  font-size: 0.5rem;
  cursor: pointer;
  font-weight: 600;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
}

.common-input-container {
  padding: 0 0.8rem;
}

.common-label-text {
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.2rem;
  margin-top: 1.2rem;
  color: #202020;
}

.common-input-text {
  width: 100%;
  border: 1px solid #e6e6e6;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: #202020;
  font-weight: 500;
}

.card-container input[type='submit'],
.user-account-verify-account-container button {
  float: right;
  margin: 1rem 0.8rem 0 0;
  border: none;
  background: #f05a9b;
  padding: 0.5rem 1.5rem;
  font-size: 0.7rem;
  border-radius: 4px;
  color: #ffffff;
}

h4.edit-bank-account-title {
  margin-left: 0.75rem;
  font-size: 1.2rem;
  color: #202020;
}

.user-account-verify-account-container h5 {
  font-size: 0.7rem;
  color: #9d9d9d;
  margin: 1.2rem 0 0 0.75rem;
}

.user-account-verify-account-container p {
  font-size: 0.8rem;
  font-weight: 500;
  color: #202020;
  margin: 0.25rem 0 0 0.75rem;
}

.agent-dashboard-wallet-tab-header-container {
  display: flex;
  justify-content: space-between;
}

.wallet-tab-header-right {
  display: flex;
}

.agent-dashboard-wallet-tab-header-container select,
.agent-dashboard-wallet-tab-header-container input {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 1.5px;
  color: #9d9d9d;
  height: 30px;
  border: 1px solid #dcdcdc;
  font-size: 0.8rem;
  padding: 0.3rem 1.5rem 0.3em 0.5rem;
  margin-left: 0.5rem;
}

.agent-dashboard-wallet-tab-header-container select:focus {
  outline: none;
}

.agent-dashboard-wallet-tab-header-container input::placeholder {
  color: #9d9d9d;
}

#agent-dashboard-referral-tab-table-container td.green {
  color: #06a759;
  text-transform: capitalize;
}

#agent-dashboard-referral-tab-table-container td.red {
  color: #f5222d;
  text-transform: capitalize;
}

.wallet-tab-header-right input,
.wallet-tab-header-right select {
  cursor: pointer;
}

.first-letter-capitalize {
  text-transform: lowercase;
}

.first-letter-capitalize:first-letter {
  text-transform: capitalize;
}

.search-box-container input {
  border: none;
}

.search-box-container input {
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: none;
  background-repeat: no-repeat;
  height: unset;
  border: none;
  font-size: 0.8rem;
  padding: 0;
  margin-left: 0;
}

/* Loader 2 */
.loader-x {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
}

.loader-text {
  font-size: 25px;
  letter-spacing: 0.1em;
  font-weight: 900;
}

.aboslute-margin-8 {
  position: absolute;
  right: 8;
  top: 8;
}

.display-none {
  display: none;
}

.simple-flex {
  display: flex;
  flex-flow: row wrap;
}

.margin-left--37 {
  margin-left: -37px;
}

.opacity-full {
  opacity: 1;
}

.opacity-zero {
  opacity: 0;
}

.opacity-low-mid {
  opacity: 0.24;
}

.background-white {
  background-color: #fff;
}
.post-message-toast-container {
  position: fixed;
  right: 2rem;
  bottom: 1rem;
}

.post-response-disclaimer-container {
  padding: 1rem 2rem;
  background: #222;
  width: fit-content;
  border-radius: 0.2rem;
  color: #fff;
}

.post-response-disclaimer-container button.link-type-button {
  margin-left: 1rem;
  background: #fff;
  padding: 0.25rem 0.5rem;
  border-radius: 0.2rem;
}

.red-disclaimer-for-post {
  color: red;
}

.outstanding-payment-total-container {
  border-bottom: 1px solid #f5f5f5;
  padding: 0 1rem 1rem 1rem;
  font-weight: 600;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.payment-tab-outstanding-order-number {
  background-color: #f5f5f5;
  padding: 1rem;
  font-weight: 600;
  font-size: 0.8rem;
}

span.outstanding-payment-total-order-value {
  float: right;
}

span.outstanding-payment-total-value {
  float: right;
}

.payment-outstanding-margin {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
}

.payment-outstanding-sub-order-container {
  font-size: 0.8rem;
  font-size: 0.8rem;
  margin: 1rem 0;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem 1rem;
}

span.outstanding-payment-value {
  float: right;
}

.outstanding-payment-span-container {
  margin-top: 0.5rem;
}

.payment-outstanding-sub-order-margin-container {
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;
}

span.payment-outstanding-sub-order-title-value {
  float: right;
}

span.payment-outstanding-sub-order-title {
  font-weight: 500;
}

.post-message-toast-loader {
  font-size: 0.8rem;
}

#agent-dashboard-date-time-container
  .react-datepicker-popper[data-placement^='bottom'] {
  margin-left: -40px;
}

select.select-escalation-type {
  display: block;
  border: 1px solid #d2d2d2;
}

.search-box-outer-container {
  display: flex;
}

.stick-bottom {
  position: static;
  bottom: 0;
  margin-top: 20px;
}

.card-body-2 {
  height: 281px;
  width: 100%;
  border-radius: 4px;
  border: solid 1px #f0f0f5;
  background-color: #fff;
  padding: 10px;
}

.clear-apply-button-for-date-filer {
  display: flex;
  width: 80px;
  justify-content: space-between;
}

.react-datepicker-popper .react-datepicker {
  margin-left: -16px !important;
}

.fixed-length-agd {
  max-width: 180px;
  word-wrap: break-word;
}

.clp-admin-summary {
  border-radius: 4px;
  border: solid 1px #FADA9D;
  background-color: #FBF1D3;
  padding: 14px;
  width: 60%;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/agentDashboard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;;EAEnB,OAAO;EACP,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,OAAO;AACT;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;;EAEzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;;EAEX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;;EAEnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;;EAEd,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;;EAEd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;;EAEd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B;;;;GAIC;EACD,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B;;;;GAIC;EACD,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;;EAEnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yDAA2N;EAC3N,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".custom-card {\n  border-radius: 4px;\n  border: solid 1px #cfcfcf;\n  background-color: #fff;\n  padding: 14px;\n}\n.noresult-found {\n  font-size: 12px;\n  margin-top: 30px;\n  opacity: 0.7;\n  text-align: center;\n}\n\n.custom-card-label {\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #9d9da6;\n  text-transform: capitalize;\n  margin: 0px;\n}\n\n.disable-button {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.button-hover:hover {\n  cursor: pointer;\n}\n\n.model-absolute-position {\n  position: absolute;\n  left: 47%;\n  top: 47%;\n}\n\n.popup-yellow-background {\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  margin: 5px 0px;\n  text-align: center;\n  background-color: #f5e12d80;\n  display: block;\n}\n\n.payments-none-disclaimer-1 {\n  color: #6b6b6b;\n  font-size: 0.8rem;\n  /* padding-top: 1rem; */\n  display: flex;\n  justify-content: center;\n}\n\n.low-underline {\n  display: block;\n  height: 2px;\n  width: 100%;\n  background-color: #f0f0f5;\n  position: absolute;\n  top: 65px;\n  z-index: 98;\n}\n\n.custom-card-text {\n  margin: 0px;\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n}\n\n.custom-tag {\n  font-size: 12px;\n  border-radius: 100px;\n  background-color: #e9e9e9b4;\n  padding: 2px 0px;\n  /* max-width: 70px; */\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 8px;\n  margin-bottom: 10px;\n}\n\n.custom-tag-image {\n  height: 24px;\n}\n\n.action-button-pink {\n  color: #eb4f85;\n  font-size: 20px;\n  margin-left: 10px;\n}\n\n.full-height-layout {\n  height: 100vh;\n  background-color: #f0f0f0;\n  padding: 20px;\n}\n\n.full-height-layout-90 {\n  height: 85vh;\n  background-color: #f0f0f09f;\n  padding: 20px;\n  border-radius: 4px;\n  width: 300px;\n}\n\n.flex-column-padding-15 {\n  display: flex;\n  flex-direction: column;\n  padding: 15px;\n  align-items: flex-start;\n}\n\n.flex-column-gap {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1;\n}\n\n.raw-flex-row {\n  display: flex;\n  flex-flow: row wrap;\n}\n\n.raw-flex-row-center {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n\n.raw-flex-col-center {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n\n.raw-flex-row-reverse {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row;\n  margin: 5px 0px;\n  align-items: center;\n}\n\n.flex-row-start {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: flex-start;\n}\n\n.flex-row-full-width {\n  display: flex;\n  flex-direction: row;\n  margin: 5px 0px;\n  align-items: center;\n\n  flex: 1;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.flex-row-center {\n  display: flex;\n  flex-direction: row;\n  margin: 5px 0px;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-row-vertical-center {\n  display: flex;\n  flex-direction: row;\n  margin: 5px 0px;\n  justify-content: space-between;\n}\n\n.flex-row-horizontal-gap {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n}\n\n.flex-row-gap-start {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.flex-row-end {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.flex-row-gap {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.underline {\n  display: block;\n  min-width: 76px;\n  height: 2px;\n  background-color: #eb4f85;\n  z-index: 100;\n  position: absolute;\n  top: 65px;\n}\n\n.tab-header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 1;\n}\n\n.tab-header-name {\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #787887;\n}\n\n.tab-header-name:hover {\n  cursor: pointer;\n}\n\n.tab-header-name-active {\n  font-size: 12px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #f05a9b;\n}\n\n.tab-header-item {\n  text-align: center;\n  justify-content: center;\n  min-width: 76px;\n  margin-right: 15px;\n}\n\n.tab-body {\n  margin-top: 15px;\n}\n\n.meesho-primary-button {\n  min-width: 114px;\n  height: 30px;\n  border-radius: 4px;\n  border: solid 1px #eb4f85;\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 12px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: #eb4f85;\n}\n.meesho-primary-button:hover {\n  background-color: #eb4f85;\n  color: #fff;\n  cursor: pointer;\n}\n\n.meesho-primary-active-button {\n  margin: 0px 15px;\n  width: 114px;\n  height: 30px;\n  border-radius: 4px;\n  border: solid 1px #eb4f85;\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  justify-content: center;\n  background-color: #eb4f85;\n\n  font-size: 12px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: #fff;\n\n  cursor: pointer;\n}\n\n.meesho-primary-active-button:hover {\n  cursor: pointer;\n}\n\n.right-shift {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.box {\n  width: 166px;\n  height: 30px;\n  border-radius: 2px;\n  border: solid 1px #dcdcdc;\n  padding: 0px 3px;\n  padding-left: 5px;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.box-row {\n  width: 166px;\n  height: 30px;\n  border-radius: 2px;\n  border: solid 1px #dcdcdc;\n  padding: 0px 6px;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 7px;\n}\n\n.input-placeholer {\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #9d9da6;\n  margin-top: 5px;\n}\n\n.box-input {\n  min-width: 166px;\n  height: 30px;\n  border-radius: 2px;\n  border: solid 1px #dcdcdc;\n  padding: 0px 3px;\n  padding-left: 5px;\n  padding-right: 20px;\n\n  font-size: 13px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #9d9da6;\n\n  /* background-color: #dcdcdc; */\n}\n\n.fluid-row {\n  width: 100%;\n}\n\n.fluid-row-padding-10 {\n  width: 100%;\n  padding: 0px 10px;\n}\n\n.fluid-row-full-flex {\n  width: 100%;\n  padding: 0px 10px;\n  flex: 1;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-2 {\n  flex: 2;\n}\n\n.flex-3 {\n  flex: 3;\n}\n\n.flex-4 {\n  flex: 4;\n}\n\n.flex-5 {\n  flex: 5;\n}\n\n.flex-6 {\n  flex: 6;\n}\n\n.table-body-text {\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.29;\n  letter-spacing: normal;\n  text-align: left;\n  color: #52616a;\n}\n\n.table-image {\n  height: 45px;\n  width: 45px;\n  border-radius: 4px;\n}\n\n.table-footer-mid-text {\n  background-color: #f5f5f5;\n  margin: 0px 15px;\n  padding: 7px 14px;\n  border-radius: 4px;\n}\n\n.table-default-horizontal-gap {\n  margin: 0px 25px;\n}\n\n.table-default-vertical-gap {\n  margin: 30px 0px;\n}\n\n.table-header-row {\n  border: 0px;\n  background-color: #f2f2f2;\n  padding: 10px;\n}\n.table-header{\n  border-top: 1px solid #000;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.table-item-align-left {\n  border: 0px;\n  text-align: left;\n}\n\n.circle {\n  width: 9px;\n  height: 9px;\n  width: 10px;\n  min-width: 10px;\n  height: 10px;\n  min-height: 10px;\n  border-radius: 100px;\n  background-color: #000;\n  border: 0.3px solid rgb(187, 187, 187);\n}\n\n.maximum-width-650 {\n  max-width: 650px;\n}\n\n.color-picker-input-box {\n  border: 1px solid #dcdcdc;\n  margin-left: 5px;\n  padding: 5px 10px;\n  font-size: 13px;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  cursor: pointer;\n  min-width: 150px !important;\n}\n\n.color-picker-input-box-ul {\n  background-color: rgb(255, 255, 255);\n  padding: 5px 3px;\n  opacity: 1;\n  color: #9d9d9d;\n  position: absolute;\n  z-index: 100;\n  min-width: 150px !important;\n  font-size: 13px;\n  border: 1px solid rgb(129, 129, 129);\n  border-radius: 4px;\n  right: 15px;\n  border-top-width: 0px;\n  border-top-right-radius: 0px;\n  border-top-left-radius: 0px;\n  padding-left: 5px;\n}\n\n.color-picker-input-box-ul-li {\n  display: flex;\n  flex-direction: row;\n  cursor: pointer;\n}\n\n.color-picker-color-circle {\n  margin-right: 5px;\n  height: 15px;\n  width: 15px;\n  border-radius: 100px;\n  /* background-color: red; */\n  border: 0.5px solid rgba(141, 141, 141, 0.753);\n}\n\n.color-picker-input-box-ul-li-circle {\n  margin-right: 5px;\n  height: 10px;\n  width: 10px;\n  border-radius: 100px;\n  /* background-color: red; */\n  border: 0.5px solid rgba(144, 144, 144, 0.753);\n  margin-top: 3px;\n}\n\n.circle-color-red {\n  background-color: #f05a9b;\n  margin-right: 8px;\n}\n\n.circle-color-orange {\n  background-color: #f6691e;\n  margin-right: 8px;\n}\n.circle-color-green {\n  background-color: #06a759;\n  margin-right: 8px;\n}\n\n.position-relative {\n  position: relative;\n}\n\n.floating-error-message-input-field {\n  margin-top: -3px;\n}\n\n.position-absolute-bottom-10 {\n  position: absolute;\n  bottom: 0px;\n}\n\n.position-relative-z-200 {\n  position: relative;\n  z-index: 200;\n}\n\n.position-absolute-top-right {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n\n.position-absolute-top-right-10 {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n.position-absolute-top-right-15 {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n.position-absolute-top-right-20 {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n.position-absolute-right {\n  position: absolute;\n  right: 10;\n  bottom: 1;\n}\n\n.margin-height-width-0 {\n  margin: 0px !important;\n}\n\n.top-padding-10 {\n  padding-top: 10px;\n}\n\n.bottom-margin--15 {\n  margin-bottom: -15px;\n}\n\n.horizontal-align-top {\n  align-items: top;\n}\n\n.flex-row-horizontal-gap-one {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: top;\n  text-align: left;\n}\n\n.inline-text-link-one {\n  font-size: 12px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #f05a9b !important;\n}\n\n.inline-text-link-one:hover {\n  cursor: pointer;\n}\n\n.margin-horizontal-5 {\n  margin: 0px 5px;\n}\n\n.normalise-link-button a {\n  color: #ffffff;\n  text-decoration: none;\n}\n\n.inline-text-icon {\n  width: 12px;\n  height: 12px;\n}\n\n.align-center-envelop {\n  margin-top: 4px;\n  font-size: 16px;\n}\n\n.position-absolute-right-1 {\n  position: absolute;\n  right: 0px;\n  bottom: 1;\n}\n\n.dispaly-block {\n  display: block;\n  margin-bottom: 25px;\n}\n\n.deafult-margin-top {\n  margin-top: 20px;\n}\n\n.half-padding {\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.margin-left-45-par {\n  margin-left: 45%;\n}\n\n.margin-left-5 {\n  margin-left: 5px;\n}\n\n.text-align-left-x {\n  text-align: left;\n  border: 0px;\n}\n\n.clip-scroll {\n  max-height: 60vh;\n  overflow-y: scroll;\n}\n\n.padding-5 {\n  padding: 5px;\n}\n\n.text-button {\n  color: #eb4f85;\n}\n\n.text-button:hover {\n  cursor: pointer;\n}\n\n.button-hover:hover {\n  cursor: pointer;\n}\n\n.checkbox {\n  background-color: pink;\n  color: pink;\n  border-color: pink;\n  background: pink;\n  border: pink 1px solid;\n}\n\n.checkbox:checked {\n  background-color: pink;\n}\n\n.checkbox:hover {\n  cursor: pointer;\n}\n\n.bar-1 {\n  width: 1px;\n  height: 16px;\n  opacity: 0.2;\n  background-color: #000000;\n  margin: 15px;\n}\n\n.bar-32 {\n  width: 2px;\n  height: 33px;\n  opacity: 0.2;\n  background-color: #000000;\n  margin: 0px 15px;\n}\n\n.bar-30 {\n  width: 100%;\n  height: 1px;\n  background-color: #d7d7e0;\n  margin: 30px 0px;\n}\n\n.bar-96 {\n  width: 100%;\n  height: 1px;\n  background-color: #d7d7e0;\n  margin: 25px 0px;\n}\n\n.bar-40 {\n  width: 1px;\n  height: 249px;\n  opacity: 0.2;\n  background-color: #000000;\n  margin: 0px 25px;\n}\n\n.bar-100 {\n  width: 1px;\n  height: 244px;\n  background-color: #d7d7e0;\n}\n\n.path-4 {\n  width: 1px;\n  height: 70px;\n  border: solid 1px #06a759;\n  position: absolute;\n  left: 10px;\n  top: 4px;\n  z-index: 198;\n}\n\n.heading-normal-text {\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n}\n\n.midium-size-image {\n  width: 145.1px;\n  height: 181.4px;\n  border-radius: 4px;\n}\n\n.text-group-1-label {\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #787887;\n\n  margin-bottom: 2px;\n}\n\n.text-group-1-body {\n  font-size: 14px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n\n  /* max-width: 151px; */\n}\n\n.text-group-2-heading {\n  font-size: 16px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n}\n\n.text-group-2-label {\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #787887;\n  margin-bottom: 0px;\n  text-transform: capitalize;\n}\n\n.text-group-2-heading-lite {\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  text-align: left;\n  color: #212121;\n}\n\n.text-group-2-caption {\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #9d9da6;\n  margin-bottom: 0px;\n}\n\n.text-transform-uppercase {\n  text-transform: uppercase;\n}\n\n.text-group-2-caption-lite {\n  font-size: 10px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #9d9da6;\n  margin-bottom: 0px;\n  margin: 0px;\n  margin-top: -10px;\n}\n\n.text-group-2-caption-lite-1 {\n  font-size: 10px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #9d9da6;\n  margin-bottom: 10px;\n  margin-top: -6px;\n}\n.text-group-2-caption-header {\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.33;\n  letter-spacing: normal;\n  text-align: left;\n  color: #787887;\n}\n\n.text-group-2-caption-pink {\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #f05a9b;\n}\n\n.text-group-2-caption-pink:hover {\n  cursor: pointer;\n}\n\n.text-group-2-body {\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n}\n\n.text-group-3-label {\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #9d9da6;\n  margin-top: 14px;\n  margin-bottom: 0px;\n}\n\n.text-group-4-label {\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #0a0a0a;\n  margin-top: -10px;\n  margin-bottom: 0px;\n}\n\n.model-textarea {\n  width: 100%;\n  margin: 15px 0px;\n  border-color: rgb(129, 129, 129);\n}\n\n.text-group-3-body {\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n}\n\n.margin-right-5 {\n  margin-right: 5px;\n}\n\n.margin-right-15-padding-10 {\n  margin-right: 15px;\n  padding: 0px 10px;\n}\n\n.green-circle {\n  margin-right: 22px;\n  margin-left: 7px;\n  z-index: 200;\n  display: block;\n  background-color: green;\n  height: 8px;\n  width: 8px;\n  border-radius: 100px;\n  z-index: 300;\n}\n\n.gray-circle {\n  margin-right: 22px;\n  margin-left: 7.1px;\n  z-index: 200;\n  display: block;\n  background-color: rgb(255, 255, 255);\n  height: 7px;\n  width: 7px;\n  border: 1px solid rgb(133, 133, 133);\n  border-radius: 100px;\n  z-index: 300;\n}\n\n.green-big-circle {\n  z-index: 398;\n  top: -2px;\n  position: absolute;\n  display: block;\n  opacity: 0.24;\n  background: rgb(255, 255, 255);\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 1) 0%,\n    rgba(6, 167, 89, 1) 100%\n  );\n  height: 22px;\n  width: 22px;\n  border-radius: 100px;\n}\n\n.orange-circle {\n  margin-right: 22px;\n  margin-left: 7px;\n  z-index: 200;\n  display: block;\n  background-color: #ff9115;\n  height: 8px;\n  width: 8px;\n  border-radius: 100px;\n  z-index: 300;\n}\n\n.orange-big-circle {\n  z-index: 298;\n  top: -2px;\n  position: absolute;\n  display: block;\n  opacity: 0.24;\n  background: rgb(255, 255, 255);\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 1) 0%,\n    rgba(246, 105, 30, 1) 100%\n  );\n  height: 22px;\n  width: 22px;\n  border-radius: 100px;\n}\n\n.red-outer-circle {\n  margin-right: 15px;\n  display: block;\n  background-color: red;\n  height: 22px;\n  width: 22px;\n  border-radius: 100px;\n  opacity: 0.2;\n}\n\n.red-inner-circle {\n  position: absolute;\n  top: 7px;\n  left: 7px;\n  display: block;\n  background-color: red;\n  height: 8px;\n  width: 8px;\n  border-radius: 100px;\n}\n\n.flex-bar {\n  display: block;\n  height: 100%;\n  width: 1.5px;\n  background-color: green;\n  opacity: 0.6;\n  flex: 1;\n  position: absolute;\n}\n\n.margin-left-10 {\n  margin-left: 10px;\n}\n\n.margin-tpp-5 {\n  margin-top: 5px;\n}\n\n.maximum-width-850 {\n  max-width: 850px;\n}\n\n.popup-position-top {\n  max-width: 70vw;\n  min-width: 750px;\n  top: 300;\n}\n\n.iframe-pdf {\n  width: 100%;\n  min-height: 340px;\n  padding-top: -100px;\n  margin: 10px 0px;\n}\n.min-width-100 {\n  min-width: 100px;\n}\n\n.maximum-height-1000-scroll {\n  margin-top: 100px;\n  max-width: 800px;\n  overflow-y: scroll;\n}\n\n.top-500 {\n  top: 500px;\n}\n\n.color-red {\n  font-size: 12px;\n  color: red;\n}\n\n.maximum-height-600-scroll {\n  max-height: 600px;\n  overflow-y: scroll;\n}\n\n.maximum-width-750 {\n  max-width: 750px;\n}\n\n.maximum-width-600 {\n  max-width: 600px;\n}\n\n.maximum-width-400 {\n  max-width: 400px;\n}\n\n.maximum-width-300 {\n  max-width: 300px;\n}\n\n.maximum-width-200 {\n  max-width: 200px;\n}\n\n.maximum-width-250 {\n  max-width: 250px;\n}\n\n.maximum-width-270 {\n  max-width: 270px;\n}\n\n.maximum-width-280 {\n  max-width: 280px;\n}\n\n.maximum-width-550 {\n  max-width: 550px;\n}\n\n.maximum-width-315 {\n  max-width: 315px;\n}\n\n.padding-horizontal-5 {\n  padding: 0px 5px;\n}\n\n.padding-horizontal-10 {\n  padding: 0px 10px;\n}\n\n.model-header-text-h1 {\n  font-size: 20px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000;\n  text-transform: capitalize;\n}\n\n.document-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.model-1-image {\n  width: 156.8px;\n  height: 196px;\n}\n\n.input-1-textbox {\n  width: 689px;\n  height: 68px;\n  border: solid 1px #e6e6e6;\n}\n\n.model-1-heading {\n  font-size: 16px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n}\n\n.input-1-label {\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n}\n\n.input-1-field {\n  width: 338px;\n  height: 33px;\n  border: solid 1px #e6e6e6;\n}\n\n.pink-bold-text {\n  text-transform: capitalize;\n  font-size: 14px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  text-align: center;\n  color: #eb4f85;\n}\n\n.minimum-width-150 {\n  min-width: 150px;\n}\n\n.margin-left-35 {\n  margin-left: 35px;\n}\n.minimum-width-270 {\n  min-width: 270px;\n}\n\n.white-line {\n  background-color: white;\n  z-index: 700;\n  margin-top: 14px;\n  opacity: 1;\n  width: 3px;\n}\n\n.text-bold-1 {\n  font-weight: 700;\n  color: #202024;\n  font-size: 14px !important;\n}\n\n.test-group-2 {\n  font-weight: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  color: #787887;\n  font-size: 14px;\n}\n\n.text-group-3 {\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: left;\n  color: #787887;\n  font-size: 12px;\n}\n\n.margin-top--5 {\n  margin-top: -5px;\n}\n.dotted-box {\n  width: 120px;\n  height: 120px;\n  border-radius: 4px;\n  border: dotted 1px #eb4f85;\n  background-color: #fff;\n  margin-right: 15px;\n}\n\n.dotted-image-box {\n  width: 120px;\n  height: 120px;\n  border-radius: 4px;\n  margin: 15px;\n  margin-left: 0px;\n  margin-bottom: 0px;\n}\n\n.color-primary {\n  color: #eb4f85;\n}\n\n.image-add-button {\n  position: absolute;\n  top: 40px;\n  left: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.lite-border {\n  border-radius: 4px;\n  border: solid 1px #f0f0f5;\n}\n\n.search-box {\n  width: 269px;\n  height: 33px;\n  border-radius: 6px;\n  border: solid 1px #e6e6e6;\n  padding-left: 30px;\n}\n\n.option_bottom_border {\n  width: 100%;\n  border-bottom: 1px solid #d7d7e0;\n  text-align: left;\n  padding: 10px 0px;\n  padding-bottom: 0px;\n\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2.86;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n  margin-top: 5px;\n}\n\n.option_bottom_border:hover {\n  cursor: pointer;\n}\n\n.search-input-background {\n  padding: 40px 40px;\n  border-radius: 4px;\n  background-color: #f0f0f5;\n}\n\n.margin-horizontal-10 {\n  margin: 0px 5px;\n}\n\n.margin-vertical-30 {\n  margin: 30px 0px;\n}\n\n.submit-button {\n  border: 0px;\n  width: 343px;\n  height: 47px;\n  border-radius: 4px;\n  background-color: #f05a9b;\n  text-align: center;\n\n  font-size: 16px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #fff;\n}\n\n.autosuggest-inputbox {\n  height: 52px;\n  border-radius: 6px;\n  border: solid 1px #e6e6e6;\n  background-color: #fff;\n}\n\n.search-box-holder {\n  margin-top: 10vh;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.bonus-box {\n  border-radius: 2px;\n  border: solid 1px #d7d7e0;\n  padding: 10px;\n  margin-right: 20px;\n}\n\n.bonus-box-label {\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #53616a;\n}\n\n.bonus-box-text {\n  font-size: 20px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: left;\n  color: #202024;\n  margin-bottom: 0px;\n}\n\n.bonus-section-heading {\n  font-size: 16px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  color: #53616a;\n}\n\n.text-align-right-x {\n  text-align: right;\n  border: 0px;\n}\n\n.table-bonus-row {\n  height: 80px;\n}\n\n.margin-bottom-6 {\n  margin-bottom: 6px;\n}\n\n.margin-bottom-3 {\n  margin-bottom: 3px;\n}\n\n.margin-bottom-10 {\n  margin-bottom: 10px;\n}\n\n.margin-bottom-20 {\n  margin-bottom: 20px;\n}\n\n.margin-right-15 {\n  margin-right: 15px;\n}\n\n.margin-right-35 {\n  margin-right: 35px;\n}\n\n.disposition-select {\n  background-color: #5c8dff;\n  color: #fff;\n  border: 0px;\n  border-radius: 4px;\n  padding-left: 10px;\n  padding-bottom: 7px;\n  padding-top: 7px;\n}\n\n.minimum-width-300 {\n  min-width: 300px;\n}\n\n.long-textarea {\n  width: 100%;\n  height: 199px;\n  border: solid 1px #e6e6e6;\n  background-color: #fff;\n}\n\n.margin-top-8 {\n  margin-top: 8px;\n}\n\n.payments-col {\n  height: 611px;\n  border: solid 1px #f0f0f5;\n  overflow-y: auto;\n}\n\n#agent-dashboard-payments-message-col table tr th,\n#agent-dashboard-payments-message-col table tr td {\n  border: 0 !important;\n  min-width: 10rem;\n  margin: 2rem 0 1rem 2rem;\n  padding: 1rem !important;\n  line-height: 1.5rem;\n  font-size: 0.8rem;\n}\n\n#agent-dashboard-payments-message-col table tr:nth-child(odd),\n#agent-dashboard-referral-tab-table-container table tr:nth-child(odd) {\n  background-color: #f5f5f5;\n}\n\n.payments-none-disclaimer {\n  color: #b4b4be;\n  padding-top: 2rem;\n  font-size: 0.8rem;\n  display: flex;\n  justify-content: center;\n}\n\n.agent-dashboard-tab-info-box-container {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 1.5rem;\n}\n\n.info-box-container {\n  border-radius: 2px;\n  border: solid 1px #d7d7d7;\n  margin-right: 0.5rem;\n  padding: 0.1rem 0.8rem 0.4rem;\n  min-width: 7.5rem;\n  width: fit-content;\n}\n\n.info-box-title {\n  color: #787887;\n  font-size: 0.7rem;\n}\n\n.info-box-value {\n  font-weight: 500;\n  color: #202020;\n  font-size: 1rem;\n  margin: 0;\n}\n\n.search-box-container {\n  width: max-content;\n  border: 1px solid #d7d7d7;\n  padding: 0.2rem 0.5rem 0.3rem;\n  margin-right: 0.5rem;\n}\n\ninput.search-box-input {\n  border: none;\n  font-size: 0.7rem;\n}\n\ninput.search-box-input::placeholder {\n  color: #9d9d9d;\n}\n\n.search-box-container i.fa.fa-search.search-box-icon {\n  color: #d7d7d7;\n  padding: 0 0.2rem;\n  position: inherit !important;\n  cursor: pointer;\n}\n\n#agent-dashboard-referral-tab-table-container {\n  margin-top: 1.2rem;\n}\n\n#agent-dashboard-referral-tab-table-container table th {\n  text-align: left;\n  border: none;\n  width: 130px;\n  padding-left: 1.5rem;\n  word-break: break-word;\n}\n.referral-table-heading-tr {\n  border: 1px solid #dcdcdc;\n}\n\n.link-type-button {\n  background: transparent;\n  border: none;\n  font-size: 0.8rem;\n  color: #f05a9b;\n  padding: 0;\n  margin: 0;\n}\n\n.link-type-button:focus {\n  outline: none;\n}\n\n.agent-dashboard-referral-tab-container {\n  margin-right: 1.5rem;\n}\n\n#agent-dashboard-referral-tab-table-container table td {\n  font-size: 0.8rem;\n  color: #52616a;\n  padding: 1.25rem 0 1.25rem 1.5rem !important;\n}\n\n#agent-dashboard-referral-tab-table-container table {\n  width: 100%;\n}\n\n.table-pagination-nav-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.table-pagination-nav-container select {\n  border: none;\n  border-radius: 2px;\n  background-color: #f5f5f5;\n  padding: 0.2rem 0.5rem;\n  font-size: 0.8rem;\n}\n\n.table-pagination-nav-container select:focus {\n  outline: none;\n}\n\n.table-pagination-summary {\n  font-size: 0.8rem;\n  color: #787878;\n  padding-left: 0.5rem;\n  padding-right: 1rem;\n}\n\n.table-pagination-nav-container a {\n  text-decoration: none;\n  cursor: pointer;\n  color: #ccc;\n  font-size: 1rem;\n  padding: 0.5rem;\n}\n\n.table-pagination-nav-container a:hover {\n  color: black;\n}\n\n.table-pagination-current-page-text {\n  background-color: #f5f5f5;\n  color: #666;\n  font-size: 0.8rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n.referral-tab-table-arrow-navigation-container {\n  margin-left: 5rem;\n}\n\n.return-to-referral-overview-container {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n\n.return-to-referral-text {\n  margin-left: 0.5rem;\n}\n\n.common-tab-buttons {\n  background-color: transparent;\n  color: #787878;\n  border: none;\n  font-size: 0.7rem;\n  min-width: 7rem;\n  margin: 0 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid transparent;\n  font-weight: 500;\n}\n\n.common-tab-buttons:focus,\n.user-account-verify-account-container button:focus {\n  outline: none;\n}\n\n.active-tab-button {\n  color: #f05a9b;\n  border-bottom: 2px solid #f05a9b;\n  font-weight: 500;\n}\n\n.common-tab-content-container {\n  padding-top: 1rem;\n  border-top: 2px solid #f5f5f5;\n  margin-top: -2px;\n}\n\n.agent-dashboard-user-account-tab-container h5 {\n  text-transform: capitalize;\n}\n\n.agent-dashboard-user-account-tab-container td button.link-type-button {\n  margin: 0 1rem 0 0;\n  font-weight: 500;\n}\n\n.card-container {\n  background-color: #ffffff;\n  width: 390px;\n  padding: 1rem;\n}\n\n.agent-dashboard-modal {\n  background-color: rgba(0, 0, 0, 0.8);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-modal-btn {\n  color: #ffffff;\n  background: #666;\n  border-radius: 50%;\n  height: 1rem;\n  width: 1rem;\n  font-size: 0.5rem;\n  cursor: pointer;\n  font-weight: 600;\n  float: right;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n}\n\n.common-input-container {\n  padding: 0 0.8rem;\n}\n\n.common-label-text {\n  font-size: 0.8rem;\n  font-weight: 500;\n  margin-bottom: 0.2rem;\n  margin-top: 1.2rem;\n  color: #202020;\n}\n\n.common-input-text {\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8rem;\n  color: #202020;\n  font-weight: 500;\n}\n\n.card-container input[type='submit'],\n.user-account-verify-account-container button {\n  float: right;\n  margin: 1rem 0.8rem 0 0;\n  border: none;\n  background: #f05a9b;\n  padding: 0.5rem 1.5rem;\n  font-size: 0.7rem;\n  border-radius: 4px;\n  color: #ffffff;\n}\n\nh4.edit-bank-account-title {\n  margin-left: 0.75rem;\n  font-size: 1.2rem;\n  color: #202020;\n}\n\n.user-account-verify-account-container h5 {\n  font-size: 0.7rem;\n  color: #9d9d9d;\n  margin: 1.2rem 0 0 0.75rem;\n}\n\n.user-account-verify-account-container p {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #202020;\n  margin: 0.25rem 0 0 0.75rem;\n}\n\n.agent-dashboard-wallet-tab-header-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.wallet-tab-header-right {\n  display: flex;\n}\n\n.agent-dashboard-wallet-tab-header-container select,\n.agent-dashboard-wallet-tab-header-container input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='light-grey' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n  background-repeat: no-repeat;\n  background-position-x: 100%;\n  background-position-y: 1.5px;\n  color: #9d9d9d;\n  height: 30px;\n  border: 1px solid #dcdcdc;\n  font-size: 0.8rem;\n  padding: 0.3rem 1.5rem 0.3em 0.5rem;\n  margin-left: 0.5rem;\n}\n\n.agent-dashboard-wallet-tab-header-container select:focus {\n  outline: none;\n}\n\n.agent-dashboard-wallet-tab-header-container input::placeholder {\n  color: #9d9d9d;\n}\n\n#agent-dashboard-referral-tab-table-container td.green {\n  color: #06a759;\n  text-transform: capitalize;\n}\n\n#agent-dashboard-referral-tab-table-container td.red {\n  color: #f5222d;\n  text-transform: capitalize;\n}\n\n.wallet-tab-header-right input,\n.wallet-tab-header-right select {\n  cursor: pointer;\n}\n\n.first-letter-capitalize {\n  text-transform: lowercase;\n}\n\n.first-letter-capitalize:first-letter {\n  text-transform: capitalize;\n}\n\n.search-box-container input {\n  border: none;\n}\n\n.search-box-container input {\n  border: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-image: none;\n  background-repeat: no-repeat;\n  height: unset;\n  border: none;\n  font-size: 0.8rem;\n  padding: 0;\n  margin-left: 0;\n}\n\n/* Loader 2 */\n.loader-x {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: block;\n}\n\n.loader-text {\n  font-size: 25px;\n  letter-spacing: 0.1em;\n  font-weight: 900;\n}\n\n.aboslute-margin-8 {\n  position: absolute;\n  right: 8;\n  top: 8;\n}\n\n.display-none {\n  display: none;\n}\n\n.simple-flex {\n  display: flex;\n  flex-flow: row wrap;\n}\n\n.margin-left--37 {\n  margin-left: -37px;\n}\n\n.opacity-full {\n  opacity: 1;\n}\n\n.opacity-zero {\n  opacity: 0;\n}\n\n.opacity-low-mid {\n  opacity: 0.24;\n}\n\n.background-white {\n  background-color: #fff;\n}\n.post-message-toast-container {\n  position: fixed;\n  right: 2rem;\n  bottom: 1rem;\n}\n\n.post-response-disclaimer-container {\n  padding: 1rem 2rem;\n  background: #222;\n  width: fit-content;\n  border-radius: 0.2rem;\n  color: #fff;\n}\n\n.post-response-disclaimer-container button.link-type-button {\n  margin-left: 1rem;\n  background: #fff;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.2rem;\n}\n\n.red-disclaimer-for-post {\n  color: red;\n}\n\n.outstanding-payment-total-container {\n  border-bottom: 1px solid #f5f5f5;\n  padding: 0 1rem 1rem 1rem;\n  font-weight: 600;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n.payment-tab-outstanding-order-number {\n  background-color: #f5f5f5;\n  padding: 1rem;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\nspan.outstanding-payment-total-order-value {\n  float: right;\n}\n\nspan.outstanding-payment-total-value {\n  float: right;\n}\n\n.payment-outstanding-margin {\n  padding: 0.5rem 1rem;\n  font-size: 0.8rem;\n}\n\n.payment-outstanding-sub-order-container {\n  font-size: 0.8rem;\n  font-size: 0.8rem;\n  margin: 1rem 0;\n  border-top: 1px solid #f5f5f5;\n  padding: 0.5rem 1rem;\n}\n\nspan.outstanding-payment-value {\n  float: right;\n}\n\n.outstanding-payment-span-container {\n  margin-top: 0.5rem;\n}\n\n.payment-outstanding-sub-order-margin-container {\n  display: flex;\n  justify-content: space-between;\n  margin: 0.5rem 0;\n}\n\nspan.payment-outstanding-sub-order-title-value {\n  float: right;\n}\n\nspan.payment-outstanding-sub-order-title {\n  font-weight: 500;\n}\n\n.post-message-toast-loader {\n  font-size: 0.8rem;\n}\n\n#agent-dashboard-date-time-container\n  .react-datepicker-popper[data-placement^='bottom'] {\n  margin-left: -40px;\n}\n\nselect.select-escalation-type {\n  display: block;\n  border: 1px solid #d2d2d2;\n}\n\n.search-box-outer-container {\n  display: flex;\n}\n\n.stick-bottom {\n  position: static;\n  bottom: 0;\n  margin-top: 20px;\n}\n\n.card-body-2 {\n  height: 281px;\n  width: 100%;\n  border-radius: 4px;\n  border: solid 1px #f0f0f5;\n  background-color: #fff;\n  padding: 10px;\n}\n\n.clear-apply-button-for-date-filer {\n  display: flex;\n  width: 80px;\n  justify-content: space-between;\n}\n\n.react-datepicker-popper .react-datepicker {\n  margin-left: -16px !important;\n}\n\n.fixed-length-agd {\n  max-width: 180px;\n  word-wrap: break-word;\n}\n\n.clp-admin-summary {\n  border-radius: 4px;\n  border: solid 1px #FADA9D;\n  background-color: #FBF1D3;\n  padding: 14px;\n  width: 60%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
